import React from 'react';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import EditIcon from '@grnhse/seedling/lib/birch/icons/edit';
import { Body, Link } from '@grnhse/seedling/lib/birch/typography';
import { Tooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { withLocalePrefix } from 'shared/utils/translation';
import { useRankingInProgress } from 'talent_matching/contexts/ranking_in_progress_context';
import { useUserContext } from 'talent_matching/contexts/user_context';
import { useCalibrationModal } from 'talent_matching/contexts/calibration_modal_context';
import { RankingDisabledReason } from 'talent_matching/types';

const t = withLocalePrefix('talent_matching.header_row');

type Props = {
  rankingDisabledReason: RankingDisabledReason | null;
};

const CalibrationButton = ({ rankingDisabledReason }: Props) => {
  const { openCalibrationModal } = useCalibrationModal();
  const { rankingInProgress, hasCalibrationSetting } = useRankingInProgress();
  const { isSiteAdmin } = useUserContext();

  let toolTipProps;
  if (rankingInProgress) {
    toolTipProps = {
      ariaLabel: t('buttons.ranking_tooltip'),
      label: t('buttons.ranking_tooltip'),
    };
  }

  if (rankingDisabledReason) {
    toolTipProps = {
      ariaLabel: rankingDisabledReason.text || '',
      label: (
        <>
          <Body>{rankingDisabledReason.text}</Body>
          {isSiteAdmin && (
            <Link href={rankingDisabledReason.path}>
              {rankingDisabledReason.link_text}
            </Link>
          )}
        </>
      ),
    };
  }

  const label = t(
    hasCalibrationSetting
      ? 'buttons.update_calibration'
      : 'buttons.create_calibration'
  );

  return toolTipProps ? (
    <Tooltip {...toolTipProps}>
      <SecondaryButton disabled icon={EditIcon}>
        {label}
      </SecondaryButton>
    </Tooltip>
  ) : (
    <SecondaryButton onClick={openCalibrationModal} icon={EditIcon}>
      {label}
    </SecondaryButton>
  );
};

export default CalibrationButton;
